'use strict'

import Vue from 'vue'

// импортируем класс плагина
import AmpliVarStatPlugin from './ampli_var_stat/index'

// пока не уверен, что нужно для класса Vue.use делать, а не для экземпляра с настройками
// однако для плагина Vuetify такой вызов есть
// Vue.use(AmpliVarStat)

// создаем экземпляр плагина с настройками
// этот место относится к приложению pgm_tools-front, в котором используется плагин,
// здесь можем настраить плагин для использования
export default new AmpliVarStatPlugin({
	// параметры какие-нибудь передать можно, если понадобится
})

